<app-print-card-template-list></app-print-card-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreatePrintCardTemplateModal()">
    Create Print Card Template
  </lib-button-primary>
</lib-button-input-portal>
